var _Circle, _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
function SvgCircleX(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 9,
    cy: 9,
    r: 6.75,
    stroke: "#FB6107",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M7.854 7.146a.5.5 0 10-.708.708l.708-.708zm2.292 3.708a.5.5 0 00.708-.708l-.708.708zm.708-3a.5.5 0 00-.708-.708l.708.708zm-3.708 2.292a.5.5 0 00.708.708l-.708-.708zm0-2.292l3 3 .708-.708-3-3-.708.708zm3-.708l-3 3 .708.708 3-3-.708-.708z",
    fill: "#FB6107"
  })));
}
export default SvgCircleX;